import DataHandlerService from "@/services/data";
import ContentService from "@/services/content";
import FileUtils from "@/utils/file";
import RandomValues from "@/utils/random";
import AddToMap from "../AddToMap/AddToMap.vue"
import InMemoryDb from "@/services/inmemorydb";
import { mapState, mapActions } from "vuex";

const InMemoryDatabase = new InMemoryDb();
const data = new DataHandlerService();
const contentService = new ContentService();
const fileUtils = new FileUtils();
const randomValues = new RandomValues();
import { VueEditor } from "vue2-editor";

import { toolbarOptions } from '../../../constants/editortoolbar.js';

export default {
  name: "new-topic",
  props: ["circle_id", "circleState", "CIRCLE_STATES", "selectedTopic"],
  components: { AddToMap, VueEditor },
  data() {
    return {
      user: data.getUserData(),
      title: this.$props.selectedTopic.title || '',
      titleRef: {
        dirty: false,
        invalid: true
      },
      body: (this.$props.selectedTopic.first_media && this.$props.selectedTopic.first_media.body) || '',
      bodyRef: {
        dirty: false,
        invalid: true
      },
      STATES: ["DEFAULT", "PROCESSING"],
      state: "",
      images: [],
      coordinates: null,
      toolbarOptions: toolbarOptions
    };
  },
  created() {
    this.setState(this.STATES[0]);
    this.titleRef.invalid = this.$props.selectedTopic.title ? false : true
    this.bodyRef.invalid = this.$props.selectedTopic.first_media.body ? false : true
  },
  computed: {
    formIsValid: function() {
      return !this.titleRef.invalid && !this.bodyRef.invalid;
    }
  },
  watch: {
    title: function(val) {
      this.titleRef.dirty = true;
      if (val === "") {
        this.titleRef.invalid = true;
      } else {
        this.titleRef.invalid = false;
      }
    },
    body: function(val) {
      this.bodyRef.dirty = true;
      if (val === "") {
        this.bodyRef.invalid = true;
      } else {
        this.bodyRef.invalid = false;
      }
    }
  },
  methods: {
    ...mapActions(["fetchCircles"]),
    resetForm() {
      this.title = "";
      this.body = "";

      this.titleRef = {
        dirty: false,
        invalid: true
      };
      this.bodyRef = {
        dirty: false,
        invalid: true
      };
    },
    setState(state) {
      this.state = state;
    },
    spawnStateChangeInCirclePage(emittedState) {
      this.$emit("stateChangeFromEditTopic", emittedState);
      this.resetForm();
    },
    submit() {
      
      const form = {
        topic_id: this.$props.selectedTopic._id,
        title: this.title,
        circle_id: this.$props.selectedTopic.circle_id,
        profile_id: this.$props.selectedTopic.profile_id,
        media_id: this.$props.selectedTopic.first_media._id,
        body: this.body,
      }

      this.setState(this.STATES[7]);
      document.getElementById("btn--submit").innerHTML = "Updating";

      contentService.updateTopic(form, this.coordinates).then((res) => {
        if(res && res.topic && res.post) {
          this.$root.$emit("SaveNewTopic", res);
          this.fetchCircles(data.getUserData()._id)
        }
        this.spawnStateChangeInCirclePage(this.$props.CIRCLE_STATES[2]);
        this.$notification.new("Topic updated");
      }).catch(response => {
        this.setState(this.STATES[0]);
        document.getElementById("btn--submit").innerHTML = "Post";
        this.$root.$emit("ShowErrorNotification", response.message);
      });
    },
    selectImageFromFS() {
      if (this.images.length !== 4) {
        const hiddenImageInput = document.getElementById("image-input");
        hiddenImageInput.click();
      }
    },
    async imageSelectCallback(e) {
      const files = e.target.files || e.dataTransfer.files;
      const validationStatus = fileUtils.validateFile(files);
      if (validationStatus.valid) {
        this.images.push({
          id: randomValues.secureRandString(),
          file: files[0],
          src: await fileUtils.getSrc(files)
        });
      } else {
        this.$root.$emit("ShowErrorNotification", validationStatus.message);
      }
    },
    removeImage(imageId) {
      this.images.splice(this.images.findIndex(s => s.id === imageId), 1);
    },
    hideUploadSection() {
      const uploadGroup = document.getElementById('upload-group');
      const uploadBtn = document.getElementById('upload-btn');

      if (uploadGroup.hidden) {
        uploadGroup.hidden = false;
        uploadBtn.classList.remove("btn-light");
        uploadBtn.classList.add("btn-danger");
        uploadBtn.innerHTML = "<ion-icon name='ios-close'></ion-icon> Remove Photos";
      } else {
        uploadGroup.hidden = true;
        uploadBtn.classList.add("btn-light");
        uploadBtn.classList.remove("btn-danger");
        uploadBtn.innerHTML = "<ion-icon name='ios-images'></ion-icon> Upload Photos";
        this.images = [];
      }
    },
    setCoordinates(coordinates) {
      this.coordinates = coordinates;
    },
    onEditorBlur(quill) {
      // console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      // console.log("editor focus!", quill);
    },
    onSelectionChange(range) {
      // console.log("selection change!", range);
    }
  }
};
